import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import docImg from "../Images/doclift.png";
import vigilImg from "../Images/vigil.png";
import saasImg from "../Images/Aaas.png";
import railplotImg from "../Images/railplot.png";
import vxiomaticImg from "../Images/vxiomatic.png";

const services = [
  { image: docImg, title: "DocLift", description: "DocLift enables businesses to automate WhatsApp interactions, streamline appointment and service request management, and gain insights into physical space operations." },
  { image: vxiomaticImg, title: "Vxiomatic", description: "Vxiomatic is a proprietary SaaS platform by Orryworx Pvt. Ltd., providing cloud-based OTT content management, monetization and secure content delivery." },
  { image: saasImg, title: "Aaas", description: "Authorization-as-a-Service (AaaS) provides secure, policy-based access control for any datasource through configurable APIs. It enables data sharing with fine-grained authorization, masking, and threat protection." },
  { image: railplotImg, title: "RailPlot", description: "Our railway analytics product. It turns raw locomotive speedometer data from Laxven, Medha, Raitech, and Telpro into live dashboards — speed violations, pre-braking analysis, and crew management in one place." },
  { image: vigilImg, title: "Vigil", description: "Vigil is an AI-powered vigilance system that detects and alerts on identified individuals, enabling real-time tracking across multiple cameras to monitor movement and enhance security." },
];

const CARD_GAP = 320; // horizontal distance between each card's center

const Product = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const total = services.length;

  useEffect(() => {
    if (paused) return;
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev === total - 1 ? 0 : prev + 1));
    }, 3000);
    return () => clearInterval(interval);
  }, [paused, total]);

  const nextSlide = () => setActiveIndex((prev) => (prev === total - 1 ? 0 : prev + 1));
  const prevSlide = () => setActiveIndex((prev) => (prev === 0 ? total - 1 : prev - 1));

  return (
    <section className="w-full bg-[#f3f5f7] py-24 overflow-hidden">
      <div className="text-center mb-16">
        <h2 className="text-4xl sm:text-5xl font-extrabold text-slate-900 mb-4 tracking-tight">
          Proprietary SaaS & Platforms
        </h2>

        <div className="w-24 h-1 bg-blue-600 mx-auto mt-5 rounded-full"></div>

        <p className="max-w-4xl mx-auto mt-8 text-lg text-gray-600 leading-relaxed">
          Our proprietary SaaS platforms combine cutting-edge technology, intuitive design, and robust architecture to deliver tailored solutions that drive productivity, collaboration, and business growth.          </p>
      </div>

      <div className="relative w-full max-w-7xl mx-auto flex flex-col items-center">
        <div className="relative flex items-center justify-center w-full min-h-[550px]">
          {services.map((service, index) => {
            // Shortest signed distance from activeIndex, wraps both directions
            let offset = index - activeIndex;
            if (offset > total / 2) offset -= total;
            if (offset < -total / 2) offset += total;

            const absOffset = Math.abs(offset);
            const isCenter = absOffset === 0;
            const isAdjacent = absOffset === 1;

            const translateX = offset * CARD_GAP;
            const scale = isCenter ? 1 : isAdjacent ? 0.75 : 0.6;
            const opacity = isCenter ? 1 : isAdjacent ? 0.5 : 0;
            const zIndex = 20 - absOffset;
            const pointerEvents = absOffset <= 1 ? "auto" : "none";
            const size = isCenter
              ? { width: 380, height: 500 }
              : { width: 260, height: 400 };

            return (
              <div
                key={index}
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
                style={{
                  transform: `translateX(${translateX}px) scale(${scale})`,
                  opacity,
                  zIndex,
                  pointerEvents,
                  width: size.width,
                  height: size.height,
                  transition: "transform 0.7s ease-in-out, opacity 0.7s ease-in-out, width 0.7s ease-in-out, height 0.7s ease-in-out",
                }}
                className="absolute rounded-3xl overflow-hidden bg-white shadow-xl flex flex-col items-center text-center cursor-pointer"
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-52 object-cover"
                />
                <div className="p-6 flex flex-col items-center">
                  <h3 className="text-2xl font-bold text-black">{service.title}</h3>
                  <p className="mt-4 text-gray-600 leading-7 text-[15px]">
                    {service.description}
                  </p>
                  <Link
                    to="/portfolio"
                    className="mt-6 inline-block text-blue-600 underline hover:text-blue-800 transition"
                  >
                    Know More
                  </Link>
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex items-center gap-6 mt-10">
          <button onClick={prevSlide} className="bg-white shadow-xl w-14 h-14 rounded-full text-3xl hover:scale-110 transition-all duration-300">←</button>
          <button onClick={nextSlide} className="bg-white shadow-xl w-14 h-14 rounded-full text-3xl hover:scale-110 transition-all duration-300">→</button>
        </div>
      </div>
    </section>
  );
};

export default Product;